import { Component } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { ColorSetDisplayerComponent } from '@camelot/ui';

import { CamTranslationGrid } from '../../../translation.service';
import { AbstractCellComponent } from '../../abstract';

interface colorSet {
  textColor: string;
  backgroundColor: string;
  borderColor: string;
}

@Component({
  host: { 'data-cid': 'grid-color-set-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  template: `
    @if (this.value) {
      <div class="d-flex" style="height: 100%">
        <cam-color-set-displayer [colorSet]="this.value">
          {{ 'grid.template.color-set.preview' | translate }}</cam-color-set-displayer
        >
      </div>
    }
  `,
  imports: [ColorSetDisplayerComponent, TranslatePipe],
})
export class GridColorSetCellComponent extends AbstractCellComponent<any, colorSet> {
  constructor() {
    super();
    CamTranslationGrid.getInstance();
  }
}
